import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
import {productLogsController} from "../store/pageControllers/ProductLogsController"
import ReactJson from "react-json-view"
import ReactPaginate from "react-paginate"

export const ProductPage = observer(() => {

    useEffect(() => {
        productLogsController.loadProductsList()
    }, [])


    return <div>
        <h1>Товары</h1>

        <div>
            <div>
                <input
                    type={"text"}
                    value={productLogsController.search_query}
                    onChange={(e) => {
                        productLogsController.search_query = e.target.value
                    }}/>
            </div>
            {productLogsController.skus.map((sku, index) =>
                <div
                    key={index}
                >
                    <div
                        style={{cursor: "pointer"}}
                        onClick={() => sku.is_open = !sku.is_open}
                    >
                        <a href={sku.url}>{sku.id}</a> {sku.product_name} {sku.name} {sku.product_id} {sku.category_name}
                    </div>
                    {sku.is_open && <div>
                        <div>
                            данные товара:
                            {sku.data_to_export ? <ReactJson
                                name={false}
                                displayDataTypes={false}
                                collapsed={true}
                                src={sku.data_to_export}
                            /> : "loading"}
                        </div>
                        <div>
                            обновление остатков:
                            {sku.stock_update_data ? <ReactJson
                                name={false}
                                displayDataTypes={false}
                                collapsed={true}
                                src={sku.stock_update_data}
                            /> : "loading"}
                        </div>
                        <div>
                            обновление цен:
                            {sku.price_update_data ? <ReactJson
                                name={false}
                                displayDataTypes={false}
                                collapsed={true}
                                src={sku.price_update_data}
                            /> : "loading"}
                        </div>

                        {sku.export_product_answer && <div>
                            ответ на экспорт продукта
                            <ReactJson
                                name={false}
                                displayDataTypes={false}
                                collapsed={true}
                                src={sku.export_product_answer}
                            />
                        </div>}
                        {sku.stock_update_answer && <div>
                            ответ на обновление остатков
                            <ReactJson
                                name={false}
                                displayDataTypes={false}
                                collapsed={true}
                                src={sku.stock_update_answer}
                            />
                        </div>}
                        {sku.update_price_answer && <div>
                            ответ на обновление цены
                            <ReactJson
                                name={false}
                                displayDataTypes={false}
                                collapsed={true}
                                src={sku.update_price_answer}
                            />
                        </div>}
                    </div>}

                </div>
            )}
            {productLogsController.pages_count > 1 && <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={productLogsController.pages_count}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={productLogsController.selected_page}
                onPageChange={(selectedItem) => {
                    productLogsController.selected_page = selectedItem.selected
                }
                }
            />}

        </div>

    </div>
})